import React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';

export default () => (
  <Card>
    <CardHeader title="Administration présence" />
    <CardContent>Bonne visite sur ce site :)</CardContent>
  </Card>
);
